module.exports = __webpack_public_path__ + "static/award_card_gba-4a7c22ec2cf27c7904d6e0049b74fdd3.png";